import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import Divider from "../Components/Divider";
import CurrencyConverter from "../Components/CurrencyConverter";
import EnhancedSEO from "../Components/EnhancedSEO";
import { 
  generateMetaTags, 
  pageConfigs, 
  generateServiceSchema,
  generateProductSchema,
  generateFAQSchema
} from "../utils/seoUtils";
import { locationInfo, locationSpecs } from "./vpsData";

const servicesData = [
  {
    title: "Multi-Server Management",
    description: "Need more than one server? You can add more VPS, or even Shared and Dedicated hosting services to your account and effortlessly manage everything in one place.",
    icon: "bx bx-server",
    delay: "100",
  },
  {
    title: "Access Control",
    description: "Create passwords that grant access to specific aspects of your account. Issue one for ownership information, one for server administration, and/or one master password for everything.",
    icon: "bx bx-lock-open-alt",
    delay: "200",
  },
  {
    title: "File Management",
    description: "Use file transfer protocol (FTP) to upload, download, or modify files on your virtual server. Create as many FTP accounts as you’d like.",
    icon: "bx bx-file",
    delay: "300",
  },
  {
    title: "Advanced Capabilities",
    description: "Our VPS servers are designed from the ground up to support everything you could need, like Secure Shell (SSH) access, server-side includes, log file access and web-based managers for files, databases, and email.",
    icon: "bx bx-cog",
    delay: "400",
  },
];

const serviceCardStyle = {
  padding: '30px',
  borderRadius: '10px',
  background: '#fff',
  transition: 'all 0.3s ease-in-out',
  boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.08)',
  border: '1px solid #e9ecef',
  height: '100%',
  textAlign: 'center',
};

const serviceIconStyle = {
  fontSize: '36px',
  color: '#21a2a0',
  marginBottom: '20px',
  // display: 'inline-block',
};

function VPSserver() {
  const [selectedLocation, setSelectedLocation] = useState("India");

  // Filter to show only India
  const availableLocations = ["India"];

  const locationHandlers = {
    India: () => setSelectedLocation("India")
  };

  // Enhanced SEO configuration
  const vpsPageConfig = generateMetaTags(pageConfigs.vpsHosting);
  
  // Structured data for VPS hosting page
  const vpsStructuredData = [
    generateServiceSchema(
      "VPS Hosting Services",
      "Affordable VPS hosting in India with dedicated resources, root access, and guaranteed performance for growing websites and applications."
    ),
    generateProductSchema(
      "VPS Hosting Plan",
      "Powerful VPS hosting with SSD storage, root access, and dedicated resources",
      "299"
    ),
    generateFAQSchema([
      {
        question: "What is VPS hosting?",
        answer: "VPS (Virtual Private Server) hosting provides dedicated resources within a virtual environment. You get guaranteed CPU, RAM, and storage with root access for complete control over your server."
      },
      {
        question: "Do I get root access with VPS hosting?",
        answer: "Yes, all our VPS hosting plans come with full root access, allowing you to install custom software, configure settings, and have complete control over your server environment."
      },
      {
        question: "Is VPS hosting better than shared hosting?",
        answer: "VPS hosting offers better performance, security, and control compared to shared hosting. It's ideal for websites with higher traffic, custom applications, or specific server requirements."
      }
    ])
  ];

  return (
    <>
      <EnhancedSEO 
        pageConfig={vpsPageConfig}
        structuredData={vpsStructuredData}
      />
      {/* ======= Hero Section =======  */}
      <section
        id="top"
        className="sharedtop bgsharedhostingimg"
        style={{ color: "black" }}
      >
        <div className="container">
          <div className="row align-items-center py-md-3">
            <div className="col-lg-6 col-12 topseccont">
              <div className="container">
                <span className="sa-bluebg-subhead">
                  👋 Up to 30% off Vps Servers
                </span>
                <h1 className="sa-hero-h1">Budget VPS Hosting</h1>
                <p>High performance SSD VPS Hosting powered by KVM</p>
                <br />

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src="/assets/img/list-arrow.svg"
                    alt="List arrow"
                    style={{
                      transform: "rotate(90deg)",
                      margin: "0 0.7rem 0 0",
                    }}
                  ></img>
                  <span>
                    Get Cloud Backup & Recovery solution by Acronis at ₹25/GB/mo
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src="/assets/img/list-arrow.svg"
                    alt="List arrow"
                    style={{
                      transform: "rotate(90deg)",
                      margin: "0 0.7rem 0 0",
                    }}
                  ></img>
                  <span>
                    Easy, secure & automated off-server backup with fast
                    recovery
                  </span>
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src="/assets/img/list-arrow.svg"
                    alt="List arrow"
                    style={{
                      transform: "rotate(90deg)",
                      margin: "0 0.7rem 0 0",
                    }}
                  ></img>
                  <span>
                    Intuitive dashboard with flexible backup & restore options
                  </span>
                </div>
                <br />
                {/* <ul className="topseclist">
                  <li>
                    <i className="fa fa-check-square-o" aria-hidden="true"></i>
                    Get Cloud Backup & Recovery solution by Acronis at ₹25/GB/mo
                  </li>
                  <li>
                    <i className="fa fa-check-square-o" aria-hidden="true"></i>
                    Easy, secure & automated off-server backup with fast recovery
                  </li>
                  <li>
                    <i className="fa fa-check-square-o" aria-hidden="true"></i>
                    Intuitive dashboard with flexible backup & restore options
                  </li>
                </ul> */}
                <a href="#dedicatedtable" className="btn btn-primary">
                  View Plans
                </a>
                {/* <p className="topsecstrt">
                  Starts at <span>Rs.659/mo</span>
                </p> */}
              </div>
            </div>
            <div className="col-lg-6 d-none d-lg-block">
              <img
                // src="../assets/img/hostingbannerimg.png"
                src="https://res.cloudinary.com/clubhosty/image/upload/v1713702809/bubble-gum-man-with-a-tablet-checks-the-server-operation_fjb0yu.svg"
                alt="imges"
                className="img-fluid vps-hero-img bounce-img"
              />
            </div>
          </div>
        </div>
      </section>
      {/* End Hero  */}

      <main id="main">
        <section id="dedicatedtable" className="gray-bg">
          <div className="container">
            <div className="row md-m-25px-b justify-content-center text-center">
              <div className="col-lg-8">
                {/* <h3
                  className="display-5 m-25px-b black-color "
                  style={{ marginBottom: "50px" }}
                >
                  VPS Hosting Plans
                </h3> */}
              </div>
            </div>
            
            {/* Location Selection with Toggle Style */}
            <div className="row tabingcustome" style={{ marginBottom: "30px" }}>
              <div className="col-12">
                <div className="text-center mb-4">
                  <h2 className="black-color" style={{ marginBottom: "20px" }}>
                    Choose your best VPS hosting plan
                  </h2>
                  <p style={{ color: "#666", fontSize: "14px", marginBottom: "30px" }}>
                    As the best VPS hosting provider, our solutions offer the prime flexibility to host everything from a simple website and application to a full-blown eCommerce site.
                  </p>
                </div>
                
                {/* Toggle Button Container */}
                <div className="d-flex justify-content-center">
                  <div style={{ 
                    display: "inline-flex",
                    backgroundColor: "#f8f9fa",
                    padding: "4px",
                    borderRadius: "50px",
                    border: "1px solid #e9ecef",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                    position: "relative",
                    overflow: "hidden"
                  }}>
                    {/* Sliding Background */}
                    <div 
                      style={{
                        position: "absolute",
                        top: "4px",
                        left: `${availableLocations.indexOf(selectedLocation) * 100}%`,
                        width: "100%",
                        height: "calc(100% - 8px)",
                        backgroundColor: "#21bcc3",
                        borderRadius: "46px",
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        boxShadow: "0 2px 8px rgba(33, 188, 195, 0.3)"
                      }}
                    ></div>
                    
                    {/* Location Buttons */}
                    {availableLocations.map((location, index) => (
                      <button
                        key={location}
                        onClick={locationHandlers[location]}
                        style={{ 
                          position: "relative",
                          zIndex: 2,
                          backgroundColor: "transparent",
                          border: "none",
                          padding: "12px 24px",
                          borderRadius: "46px",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          color: selectedLocation === location ? 'white' : '#666',
                          fontWeight: selectedLocation === location ? '600' : '500',
                          fontSize: "14px",
                          minWidth: "140px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px"
                        }}
                      >
                        {/* Flag Icons */}
                        {location === 'India' && (
                          <img
                            src="../assets/img/india.jpg"
                            alt="India"
                            style={{ width: "20px", height: "auto" }}
                          />
                        )}
                        {location}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            
            <div className="row justify-content-center" style={{ 
              transition: "all 0.4s ease",
              transform: "translateY(0)",
              opacity: 1
            }}>
              <div className="col-md-4" style={{ 
                transition: "all 0.3s ease", 
                transitionDelay: "0.1s" 
              }}>
                <div className="prcard" style={{
                  transition: "all 0.3s ease",
                  transform: "scale(1)",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                  borderRadius: "16px",
                  overflow: "hidden"
                }}>
                  <div className="prchead">
                    <h4>NVME-1</h4>
                    <small style={{ 
                      color: "#666", 
                      fontSize: "13px",
                      display: "block",
                      marginTop: "8px",
                      marginBottom: "15px",
                      fontWeight: "600",
                      backgroundColor: "white",
                      padding: "6px 12px",
                      borderRadius: "6px",
                      border: "1px solid #e9ecef",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                    }}>
                      📍 Hosted in {locationInfo[selectedLocation].datacenter}
                    </small>
                  </div>
                  <div className="prcbody">
                    <ul>
                      <li>
                        <img src="../assets/img/cpu.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-1"].cpu}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-1"].benchmark}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/ram-memory.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-1"].ram}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-1"].ramMax}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/hard-disk.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-1"].storage}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-1"].storageMax}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/speedometer.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-1"].bandwidth}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-1"].traffic}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/cable.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-1"].ips}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-1"].ipsMax}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/price-tag.svg" alt="img" />
                        <div className="sub">
                          <h6>
                            <CurrencyConverter priceINR={459} />
                          </h6>
                          <p>/Month</p>
                        </div>
                      </li>
                      <li>
                        <Link
                          className="btn btn-conf mg2"
                          to={`https://my.clubhosty.com/index.php?rp=/store/fast-nvme-ssd-vps/nvme-1&location=${selectedLocation.toLowerCase()}`}
                        >
                          Configure Now
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-4" style={{ 
                transition: "all 0.3s ease", 
                transitionDelay: "0.2s" 
              }}>
                <div className="prcard" style={{
                  transition: "all 0.3s ease",
                  transform: "scale(1)",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                  borderRadius: "16px",
                  overflow: "hidden"
                }}>
                  <div className="prchead">
                    <h4>NVME-2</h4>
                    <small style={{ 
                      color: "#666", 
                      fontSize: "13px",
                      display: "block",
                      marginTop: "8px",
                      marginBottom: "15px",
                      fontWeight: "600",
                      backgroundColor: "white",
                      padding: "6px 12px",
                      borderRadius: "6px",
                      border: "1px solid #e9ecef",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                    }}>
                      📍 Hosted in {locationInfo[selectedLocation].datacenter}
                    </small>

                    {/* <p>Best For Cpanel</p> */}
                  </div>
                  <div className="prcbody">
                    <ul>
                      <li>
                        <img src="../assets/img/cpu.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-2"].cpu}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-2"].benchmark}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/ram-memory.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-2"].ram}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-2"].ramMax}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/hard-disk.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-2"].storage}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-2"].storageMax}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/speedometer.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-2"].bandwidth}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-2"].traffic}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/cable.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-2"].ips}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-2"].ipsMax}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/price-tag.svg" alt="img" />
                        <div className="sub">
                          <h6>
                            <CurrencyConverter priceINR={804} />
                          </h6>
                          <p>/Month</p>
                        </div>
                      </li>
                      <li>
                        <Link
                          className="btn btn-conf mg2"
                          to={`https://my.clubhosty.com/index.php?rp=/store/fast-nvme-ssd-vps/nvme-2&location=${selectedLocation.toLowerCase()}`}
                        >
                          Configure Now
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-4" style={{ 
                transition: "all 0.3s ease", 
                transitionDelay: "0.3s" 
              }}>
                <div className="prcard" style={{
                  transition: "all 0.3s ease",
                  transform: "scale(1)",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                  borderRadius: "16px",
                  overflow: "hidden"
                }}>
                  <div className="prchead">
                    <h4>NVME-3</h4>
                    <small style={{ 
                      color: "#666", 
                      fontSize: "13px",
                      display: "block",
                      marginTop: "8px",
                      marginBottom: "15px",
                      fontWeight: "600",
                      backgroundColor: "white",
                      padding: "6px 12px",
                      borderRadius: "6px",
                      border: "1px solid #e9ecef",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                    }}>
                      📍 Hosted in {locationInfo[selectedLocation].datacenter}
                    </small>
                  </div>
                  <div className="prcbody">
                    <ul>
                      <li>
                        <img src="../assets/img/cpu.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-3"].cpu}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-3"].benchmark}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/ram-memory.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-3"].ram}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-3"].ramMax}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/hard-disk.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-3"].storage}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-3"].storageMax}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/speedometer.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-3"].bandwidth}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-3"].traffic}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/cable.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-3"].ips}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-3"].ipsMax}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/price-tag.svg" alt="img" />
                        <div className="sub">
                          <h6>
                            <CurrencyConverter priceINR={1494} />
                          </h6>
                          <p>/Month</p>
                        </div>
                      </li>
                      <li>
                        <Link
                          className="btn btn-conf mg2"
                          to={`https://my.clubhosty.com/index.php?rp=/store/fast-nvme-ssd-vps/nvme-3&location=${selectedLocation.toLowerCase()}`}
                        >
                          Configure Now
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-4" style={{ 
                transition: "all 0.3s ease", 
                transitionDelay: "0.4s" 
              }}>
                <div className="prcard" style={{
                  transition: "all 0.3s ease",
                  transform: "scale(1)",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                  borderRadius: "16px",
                  overflow: "hidden"
                }}>
                  <div className="prchead">
                    <h4>NVME-4</h4>
                    <small style={{ 
                      color: "#666", 
                      fontSize: "13px",
                      display: "block",
                      marginTop: "8px",
                      marginBottom: "15px",
                      fontWeight: "600",
                      backgroundColor: "white",
                      padding: "6px 12px",
                      borderRadius: "6px",
                      border: "1px solid #e9ecef",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                    }}>
                      📍 Hosted in {locationInfo[selectedLocation].datacenter}
                    </small>
                  </div>
                  <div className="prcbody">
                    <ul>
                      <li>
                        <img src="../assets/img/cpu.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-4"].cpu}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-4"].benchmark}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/ram-memory.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-4"].ram}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-4"].ramMax}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/hard-disk.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-4"].storage}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-4"].storageMax}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/speedometer.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-4"].bandwidth}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-4"].traffic}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/cable.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-4"].ips}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-4"].ipsMax}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/price-tag.svg" alt="img" />
                        <div className="sub">
                          <h6>
                            <CurrencyConverter priceINR={2299} />
                          </h6>
                          <p>/Month</p>
                        </div>
                      </li>
                      <li>
                        <Link
                          className="btn btn-conf mg2"
                          to={`https://my.clubhosty.com/index.php?rp=/store/fast-nvme-ssd-vps/nvme-4&location=${selectedLocation.toLowerCase()}`}
                        >
                          Configure Now
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-4" style={{ 
                transition: "all 0.3s ease", 
                transitionDelay: "0.5s" 
              }}>
                <div className="prcard" style={{
                  transition: "all 0.3s ease",
                  transform: "scale(1)",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                  borderRadius: "16px",
                  overflow: "hidden"
                }}>
                  <div className="prchead">
                    <h4>NVME-5</h4>
                    <small style={{ 
                      color: "#666", 
                      fontSize: "13px",
                      display: "block",
                      marginTop: "8px",
                      marginBottom: "15px",
                      fontWeight: "600",
                      backgroundColor: "white",
                      padding: "6px 12px",
                      borderRadius: "6px",
                      border: "1px solid #e9ecef",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                    }}>
                      📍 Hosted in {locationInfo[selectedLocation].datacenter}
                    </small>
                  </div>
                  <div className="prcbody">
                    <ul>
                      <li>
                        <img src="../assets/img/cpu.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-5"].cpu}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-5"].benchmark}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/ram-memory.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-5"].ram}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-5"].ramMax}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/hard-disk.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-5"].storage}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-5"].storageMax}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/speedometer.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-5"].bandwidth}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-5"].traffic}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/cable.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-5"].ips}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-5"].ipsMax}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/price-tag.svg" alt="img" />
                        <div className="sub">
                          <h6>
                            <CurrencyConverter priceINR={3449} />
                          </h6>
                          <p>/Month</p>
                        </div>
                      </li>
                      <li>
                        <Link
                          className="btn btn-conf mg2"
                          to={`https://my.clubhosty.com/index.php?rp=/store/fast-nvme-ssd-vps/nvme-5&location=${selectedLocation.toLowerCase()}`}
                        >
                          Configure Now
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-4" style={{ 
                transition: "all 0.3s ease", 
                transitionDelay: "0.6s" 
              }}>
                <div className="prcard" style={{
                  transition: "all 0.3s ease",
                  transform: "scale(1)",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                  borderRadius: "16px",
                  overflow: "hidden"
                }}>
                  <div className="prchead">
                    <h4>NVME-6</h4>
                    <small style={{ 
                      color: "#666", 
                      fontSize: "13px",
                      display: "block",
                      marginTop: "8px",
                      marginBottom: "15px",
                      fontWeight: "600",
                      backgroundColor: "white",
                      padding: "6px 12px",
                      borderRadius: "6px",
                      border: "1px solid #e9ecef",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                    }}>
                      📍 Hosted in {locationInfo[selectedLocation].datacenter}
                    </small>
                  </div>
                  <div className="prcbody">
                    <ul>
                      <li>
                        <img src="../assets/img/cpu.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-6"].cpu}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-6"].benchmark}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/ram-memory.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-6"].ram}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-6"].ramMax}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/hard-disk.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-6"].storage}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-6"].storageMax}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/speedometer.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-6"].bandwidth}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-6"].traffic}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/cable.svg" alt="img" />
                        <div className="sub">
                          <h6>{locationSpecs[selectedLocation]["NVME-6"].ips}</h6>
                          <p>{locationSpecs[selectedLocation]["NVME-6"].ipsMax}</p>
                        </div>
                      </li>
                      <li>
                        <img src="../assets/img/price-tag.svg" alt="img" />
                        <div className="sub">
                          <h6>
                            <CurrencyConverter priceINR={4599} />
                          </h6>
                          <p>/Month</p>
                        </div>
                      </li>
                      <li>
                        <Link
                          className="btn btn-conf mg2"
                          to={`https://my.clubhosty.com/index.php?rp=/store/fast-nvme-ssd-vps/nvme-6&location=${selectedLocation.toLowerCase()}`}
                        >
                          Configure Now
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <VpsComp/> */}
        {/* ======= Shared Benifits ======= */}
        <section className="hostbeni">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div>
                  <h1>
                    The Benefits of Using ClubHosty Affordable VPS hosting
                  </h1>
                  <p>
                    With VPS Hosting, you get complete isolation on With Virtual
                    Private Server (VPS) Hosting, you get complete isolation on
                    a physical server dedicated to your hosting needs. Other
                    users will have no effect on your Virtual Private Server,
                    and you will have root access to the server, allowing you to
                    install whatever applications you require on it. You will
                    always have access to the resources allocated to your VPS
                    Hosting plan, including the CPU, RAM, HDD, and Bandwidth
                    allocated to your plan. A Virtual Private Server (VPS)
                    provides you with all of the features of a Dedicated Server
                    at a more affordable price.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End Shared Bentfits  */}

        {/* ======= Services Section =======  */}
        <section id="services" className="services">
          <div className="container">
            <div className="section-title">
              <h2>Services</h2>
              <h3>
                Experience The <span>ClubHosty</span> Difference
              </h3>
            </div>

            <div className="row">
              {servicesData.map((service, index) => (
                <div className="col-md-3" data-aos-delay={service.delay} key={index}>
                  <div className="icon-box shbx" style={serviceCardStyle}>
                    <div className="icon" style={serviceIconStyle}>
                      <i className={service.icon}></i>
                    </div>
                    <h4 style={{ fontWeight: 600, marginBottom: '15px', fontSize: '18px' }}>
                      <Link to="" style={{ color: '#2c3e50', textDecoration: 'none' }}>{service.title}</Link>
                    </h4>
                    <p style={{ lineHeight: 1.6, color: '#666', textAlign: 'left' }}>{service.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        {/* End Services Section  */}
        {/* ======= Featured Services Section =======  */}
        <section
          id="featured-services"
          className="featured-services section-bg"
          style={{ padding: "60px 0px" }}
        >
          <div className="container">
            <div className="section-title" style={{ textAlign: "center", marginBottom: "40px" }}>
              <h2>Why Choose ClubHosty VPS?</h2>
              <p><strong>EXPERIENCE VPS HOSTING WITH ALL THE BELLS & WHISTLES</strong></p>
              <p style={{ textAlign: 'center' }}>Our VPS plans come fully loaded with all the latest features. Enjoy full control, customization, high-performance and more.</p>
            </div>
            <div className="row g-4">
              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713836944/latest-technologies_klswbt.svg"
                      alt="Latest Intel Technology"
                      style={{ width: "35px", height: "35px" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "15px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="">Latest Intel Technology</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    Our VPS servers are built and tested on the next-gen Intel processors and chipsets before going to the market, delivering high-speed performance.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713836989/ssh-access_fcf4ox.svg"
                      alt="SSH/SFTP Access"
                      style={{ width: "35px", height: "35px" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "15px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="">SSH/SFTP Access</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    A secure interface to access your VPS server from a computer. Install applications, software, perform updates, file changes and much more.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713837063/1gbps_a0uosx.svg"
                      alt="High-Speed Network"
                      style={{ width: "35px", height: "35px" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "15px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="">High-Speed Network</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    Fast loading times mean better results! Enjoy our unrestricted high-speed network per VPS hosting server that helps you stay ahead of the competition.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713837074/ssl-certificate_jpjv7z.svg"
                      alt="Free SSL Certificate"
                      style={{ width: "35px", height: "35px" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "15px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="">Free SSL Certificate</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    Get an encrypted connection to your website and protect all your important data. Also, win visitors' trust and rank better in Search Engines.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713837088/gauranteed-resourcess_ntaan5.svg"
                      alt="Guaranteed Resources"
                      style={{ width: "35px", height: "35px" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "15px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="">Guaranteed Resources</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    No overselling, nor the noisy neighbour problem! Thanks to our utilization of KVM hypervisors, offering guaranteed resources at all times.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div className="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713837121/operating-system-choice_tqpdic.svg"
                      alt="Operating System Choice"
                      style={{ width: "35px", height: "35px" }}
                    />
                  </div>
                  <h4 className="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "15px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="">Operating System Choice</Link>
                  </h4>
                  <p className="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    Choose from multiple Linux distributions including Ubuntu, CentOS, Debian, and more. Full root access allows you to customize your server environment.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End Featured Services Section  */}
        
        {/* ======= Operating Systems & Control Panels Section =======  */}
        <section id="os-control-panels" className="os-control-panels" style={{ padding: "80px 0", backgroundColor: "#f8f9fa" }}>
          <div className="container">
            <div className="section-title" style={{ textAlign: "center", marginBottom: "50px" }}>
              <h2>Operating Systems & Control Panels</h2>
              <h3>Choose Your <span>Perfect Setup</span></h3>
              <p style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto' }}>
                Select from a wide range of operating systems and control panels to create the perfect environment for your applications. 
                All installations come with full root access and instant deployment.
              </p>
            </div>

            {/* Operating Systems */}
            <div className="row" style={{ marginBottom: "60px" }}>
              <div className="col-12">
                <h4 style={{ textAlign: "center", marginBottom: "40px", color: "#2c3e50", fontSize: "28px", fontWeight: "600" }}>
                  Available Operating Systems
                </h4>
              </div>
              
              <div className="col-lg-3 col-md-6 mb-4">
                <div className="os-card" style={{
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                  padding: "30px 20px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
                  transition: "all 0.3s ease",
                  border: "1px solid #e9ecef"
                }}>
                  <div style={{ marginBottom: "20px" }}>
                    <img src="/assets/img/ubuntu-logo.svg" 
                         alt="Ubuntu" style={{ width: "60px", height: "60px" }} />
                  </div>
                  <h5 style={{ color: "#2c3e50", marginBottom: "15px", fontSize: "20px", fontWeight: "600" }}>Ubuntu</h5>
                  <p style={{ color: "#666", fontSize: "14px", margin: "0" }}>
                    Latest LTS versions available<br/>
                    20.04, 22.04, 24.04
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-4">
                <div className="os-card" style={{
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                  padding: "30px 20px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
                  transition: "all 0.3s ease",
                  border: "1px solid #e9ecef"
                }}>
                  <div style={{ marginBottom: "20px" }}>
                    <img src="/assets/img/centos-logo.svg" 
                         alt="CentOS" style={{ width: "60px", height: "60px" }} />
                  </div>
                  <h5 style={{ color: "#2c3e50", marginBottom: "15px", fontSize: "20px", fontWeight: "600" }}>CentOS</h5>
                  <p style={{ color: "#666", fontSize: "14px", margin: "0" }}>
                    Enterprise-grade stability<br/>
                    CentOS 7, 8, Stream
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-4">
                <div className="os-card" style={{
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                  padding: "30px 20px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
                  transition: "all 0.3s ease",
                  border: "1px solid #e9ecef"
                }}>
                  <div style={{ marginBottom: "20px" }}>
                    <img src="/assets/img/debian-logo.svg" 
                         alt="Debian" style={{ width: "60px", height: "60px" }} />
                  </div>
                  <h5 style={{ color: "#2c3e50", marginBottom: "15px", fontSize: "20px", fontWeight: "600" }}>Debian</h5>
                  <p style={{ color: "#666", fontSize: "14px", margin: "0" }}>
                    Rock-solid foundation<br/>
                    Debian 10, 11, 12
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 mb-4">
                <div className="os-card" style={{
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                  padding: "30px 20px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
                  transition: "all 0.3s ease",
                  border: "1px solid #e9ecef"
                }}>
                  <div style={{ marginBottom: "20px" }}>
                    <img src="/assets/img/fedora-logo.svg" 
                         alt="Fedora" style={{ width: "60px", height: "60px" }} />
                  </div>
                  <h5 style={{ color: "#2c3e50", marginBottom: "15px", fontSize: "20px", fontWeight: "600" }}>Fedora</h5>
                  <p style={{ color: "#666", fontSize: "14px", margin: "0" }}>
                    Cutting-edge features<br/>
                    Fedora 38, 39, 40
                  </p>
                </div>
              </div>
            </div>

            {/* Control Panels */}
            <div className="row">
              <div className="col-12">
                <h4 style={{ textAlign: "center", marginBottom: "40px", color: "#2c3e50", fontSize: "28px", fontWeight: "600" }}>
                  Available Control Panels
                </h4>
              </div>
              
              <div className="col-lg-4 col-md-6 mb-4">
                <div className="control-panel-card" style={{
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                  padding: "30px 25px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
                  transition: "all 0.3s ease",
                  border: "1px solid #e9ecef"
                }}>
                  <div style={{ marginBottom: "20px" }}>
                    <img src="/assets/img/cpanel-logo.svg" 
                         alt="cPanel" style={{ width: "80px", height: "60px" }} />
                  </div>
                  <h5 style={{ color: "#2c3e50", marginBottom: "15px", fontSize: "22px", fontWeight: "600" }}>cPanel/WHM</h5>
                  <p style={{ color: "#666", fontSize: "14px", lineHeight: "1.6", margin: "0" }}>
                    Industry-standard control panel with intuitive interface. Perfect for web hosting management, 
                    email accounts, databases, and domain administration.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 mb-4">
                <div className="control-panel-card" style={{
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                  padding: "30px 25px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
                  transition: "all 0.3s ease",
                  border: "1px solid #e9ecef"
                }}>
                  <div style={{ marginBottom: "20px" }}>
                    <img src="/assets/img/directadmin-logo.svg" 
                         alt="DirectAdmin" style={{ width: "80px", height: "60px" }} />
                  </div>
                  <h5 style={{ color: "#2c3e50", marginBottom: "15px", fontSize: "22px", fontWeight: "600" }}>DirectAdmin</h5>
                  <p style={{ color: "#666", fontSize: "14px", lineHeight: "1.6", margin: "0" }}>
                    Lightweight and fast control panel solution. Excellent performance with minimal resource usage, 
                    ideal for efficient server management.
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 mb-4">
                <div className="control-panel-card" style={{
                  backgroundColor: "#fff",
                  borderRadius: "15px",
                  padding: "30px 25px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
                  transition: "all 0.3s ease",
                  border: "1px solid #e9ecef"
                }}>
                  <div style={{ marginBottom: "20px" }}>
                    <img src="/assets/img/cyberpanel-logo.svg" 
                         alt="CyberPanel" style={{ width: "80px", height: "60px" }} />
                  </div>
                  <h5 style={{ color: "#2c3e50", marginBottom: "15px", fontSize: "22px", fontWeight: "600" }}>CyberPanel</h5>
                  <p style={{ color: "#666", fontSize: "14px", lineHeight: "1.6", margin: "0" }}>
                    Next-generation control panel with OpenLiteSpeed integration. Enhanced security features, 
                    automatic SSL, and modern web interface.
                  </p>
                </div>
              </div>
            </div>

            {/* Additional Information */}
            <div className="row" style={{ marginTop: "50px" }}>
              <div className="col-12">
                <div style={{
                  backgroundColor: "#21a2a0",
                  borderRadius: "15px",
                  padding: "40px 30px",
                  textAlign: "center",
                  color: "#fff"
                }}>
                  <h4 style={{ color: "#fff", marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>
                    Custom Installation Available
                  </h4>
                  <p style={{ color: "#fff", fontSize: "16px", lineHeight: "1.6", margin: "0", maxWidth: "800px", marginLeft: "auto", marginRight: "auto" }}>
                    Need a specific configuration? Our team can help you install custom operating systems, 
                    applications, or control panels. Contact our support team for personalized assistance 
                    with your VPS setup requirements.
                  </p>
                  <div style={{ marginTop: "30px" }}>
                    <Link to="/contact" style={{
                      backgroundColor: "#fff",
                      color: "#21a2a0",
                      padding: "12px 30px",
                      borderRadius: "8px",
                      textDecoration: "none",
                      fontWeight: "600",
                      fontSize: "16px",
                      transition: "all 0.3s ease"
                    }}>
                      Contact Support
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End Operating Systems & Control Panels Section  */}
        
        {/* ======= About Section =======  */}
        <section 
          id="about" 
          className="about section-bg" 
          style={{ 
            backgroundColor: "#ffffff", 
            padding: "80px 0",
            position: "relative",
            overflow: "hidden"
          }}
        >
          <div className="container">
            <div className="row align-items-center">
              <div
                className="col-lg-6 pt-4 pt-lg-0 content d-flex flex-column justify-content-center"
                data-aos-delay="100"
              >
                <div style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(33, 188, 195, 0.1)",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center"
                }}>
                <h3>
                  If you’re Complete server control at your fingertips you just found it.
                </h3>
                <p>
                  Our virtual private server (VPS) hosting puts you in command
                  of your website, providing you with the tools and resources to
                  create incredible websites. By utilising only high-performance
                  components, you can ensure that your websites are always
                  operating at peak performance. Furthermore, because we have
                  implemented the KVM hypervisor, we can guarantee that your
                  resources will be available at all times.
                </p>
                </div>
              </div>
              <div className="col-lg-6" data-aos-delay="100">
                <div style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(33, 188, 195, 0.1)",
                  position: "relative",
                  height: "100%"
                }}>
                  <img
                    src="https://res.cloudinary.com/clubhosty/image/upload/v1713797902/laptop_screen_ifhkxb.svg"
                    alt="VPS Server Management"
                    style={{ 
                      width: "100%",
                      maxWidth: "100%",
                      height: "auto",
                      borderRadius: "15px",
                      filter: "hue-rotate(317deg) saturate(1.2)"
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End About Section  */}
        {/* ======= Featured Services Section ======= */}
        {/* <section id="featured-services" className="featured-services">
          <div className="container">
            <div className="section-title">
              <h2>Product FAQs</h2>
              <h3>Frequently asked questions</h3>
            </div>
            <div className="row">
              <div className="col-md-4">
                <div className="icon-box" data-aos-delay="100">
                  <div className="icon">
                    <i className="#"></i>
                  </div>
                  <h4 className="title">
                    <Link to=""> What is VPS Hosting ?</Link>
                  </h4>
                  <p className="description">
                    VPS Hosting is a reliable and scalable hosting option. Users
                    are getting a secure virtualized environment like a
                    dedicated server, but at half the cost. This allows for
                    greater stability and performance of your website.
                  </p>
                </div>
              </div>

              <div className="col-md-4">
                <div className="icon-box" data-aos-delay="200">
                  <div className="icon">
                    <i className="#"></i>
                  </div>
                  <h4 className="title">
                    <Link to=""> How much activation time it takes ?</Link>
                  </h4>
                  <p className="description">
                    Once you are done with your required VPS hosting, our
                    concern team will start making setup for you immediately.
                    Once our team made complete setup and provides you login
                    credentials for your control panel then you can start
                    working on your virtual server.
                  </p>
                </div>
              </div>

              <div className="col-md-4">
                <div className="icon-box" data-aos-delay="300">
                  <div className="icon">
                    <i className="#"></i>
                  </div>
                  <h4 className="title">
                    <Link to=""> Can I install software into my account ?</Link>
                  </h4>
                  <p className="description">
                    Yes you can set up any software that runs on linux vps, you
                    can also install cPanel or other control panel on your VPS
                    to manage it.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* End Featured Services Section  */}
        {/* FAQ Start  */}
        <section id="about" className="about">
          <div className="section-title">
            <h2>Frequently Asked Questions</h2>
            {/* <p style={{ padding: "10px" }}>
						You ask, we answer! Here are the most asked questions for our Domain
						Registration service!
					</p> */}
            <Divider />
          </div>
          <div className="accordionContainer">
            <Accordion allowZeroExpanded>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What is VPS hosting?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    A virtual private server, or a VPS, as the name suggests is
                    a virtually isolated server condition. It is created after
                    dividing a physical server into several virtual servers,
                    with every server getting its dedicated resources like disk
                    space, CPU, and memory. So you will have your dedicated
                    server, but virtually. Also, as several virtual private
                    servers functioning from a single physical server, the
                    operating and maintenance costs are remarkably reduced,
                    making VPS hosting an affordable alternative to dedicated
                    servers.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Do I need to have technical knowledge to handle the VPS
                    server?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    It’s good if you’re a tech-savvy person; however, if you
                    aren’t, there’s nothing to worry about. Our expert support
                    team can take care of your VPS server while you spend time
                    growing your business. Plus, you have round-the-clock access
                    to our expert support on email, live chat, phone and tickets
                    if you run into any technical issues.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    How long will it take to provision my VPS server?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    As you sign up for our VPS plan, our team will do their best
                    to speed things up and immediately start the server
                    provisioning. Once you receive the server and control panel
                    details, you can start using your virtual server.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    How Can I Get Started with VPS Hosting?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Getting started with Best Affordable VPS Hosting is
                    easy with ClubHosty as your VPS hosting provider. Select the
                    desired package according to the needs of your website.
                    After that, complete the sign-up process, make the payment
                    and we’ll set up the server for you and you’re ready to go.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Can I install any software on my VPS hosting server?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Yes, you can. You’re free to install any third-party
                    application compatible with your VPS server. This is because
                    you have unmatched control over your server with full root
                    access.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </div>
        </section>
        {/* FAQ End  */}
      </main>
    </>
  );
}

export default VPSserver;
